export default __webpack_public_path__ + "tabletennis-live.png";